import React, { useState } from 'react'

import { cloneDeep } from 'lodash/lang'

const withState = WrappedComponent => {
  return props => {
    const {
      setEmergencyContactForm // via redux actions
    } = props

    const [formLoading, setFormLoading] = useState(true)

    const initialFormValues = {
      firstName: '',
      lastName: '',
      relationshipToCampers: '',
      legalGuardian: '',
      primaryPhone: '',
      alternatePhone: '',
      pickup: ''
    }

    if (formLoading) {
      setEmergencyContactForm(cloneDeep(initialFormValues))
      setFormLoading(false)
    }

    return <WrappedComponent formLoading={formLoading} {...props} />
  }
}

export default withState
